module.exports = __webpack_public_path__ + "static/img/ad-gsat.a5406e0e.gif";